import { UnsafePageDescription, UnsafePageTitle, UnsafePageWrapper } from '@style/pages/page.style';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';
import { OtpForm } from '@form/otp/otp.form';
import { ErrorFormInterface } from '@interface/form/error-form.interface';

import { FormWrapper } from './login-mfa.style';
import { useLoginMfa } from './use-login-mfa.hook';

export const LoginMfaPage = () => {
  const { form, error, onLogin } = useLoginMfa();

  return (
    <UnsafePageWrapper>
      <UnsafePageTitle>MFA</UnsafePageTitle>
      <UnsafePageDescription>Write your code from Authenticator</UnsafePageDescription>
      <FormWrapper>
        <OtpForm error={error as ErrorFormInterface} form={form} />
        <Button loading={false} type={ButtonTypeEnum.Primary} block ghost onClick={onLogin}>
          <Text color={ColorEnum.Inherit} level='m'>
            Validate code
          </Text>
        </Button>
      </FormWrapper>
    </UnsafePageWrapper>
  );
};
